export const dualLunchLink = "/DualLunch.pdf"
export const dualBrunchLink = "/DualBrunch.pdf"
export const dualDinnerLink = "/DualDinner.pdf"
export const directionsLink = "http://goo.gl/7hZBAe"
export const fbLink = "https://www.facebook.com/villaggiogrille/"
export const instaLink = "https://www.instagram.com/villaggiogrilleob/"
export const twitterLink = "https://twitter.com/VillaggioOBA"
export const tripLink = "http://www.tripadvisor.com/Restaurant_Review-g30753-d1074736-Reviews-Villaggio_Grille-Orange_Beach_Alabama.php"
export const yelpLink = "https://www.yelp.com/reservations/villaggio-grille-orange-beach?from_reserve_now=1"
export const opentableLink = "http://www.opentable.com/villaggio-grille-at-the-wharf-reservations-orange-beach?restref=91339"
export const ginnyLink = "http://www.ginnylanebargrill.com/"
export const yohoLink = "https://www.yohorumandtacos.com/"
export const mmLink = "https://milemarker158.com/"
export const caterLink = "https://wharfcateringgroup.com/"
export const pickupLink = "https://wharfrestaurants.revelup.online/store/1"
export const tteatLink = "https://www.timetoeatthebeach.com/order/restaurants"
export const dashLink = "https://www.doordash.com/en-NZ/store/villaggio-grille-orange-beach-27866271"
export const wharfEventLink = "https://alwharf.com/calendar/"

export function PhoneLink(props){
  return (
    <a 
      href={props.link ?? `tel:+12512246510`}
      className={`phoneLink ${props.addClass ?? 'tel'} ${props.where ?? 'uni'}`} 
    >
      {props.addText ? [props.addText] : null}
      {props.br ? <br /> : null}
      {props.callText ?? '251.224.6510'}
    </a>
  )
}
export function EmailLink(props){
  return (
    <a 
      href={props.link ?? `mailto:villaggiogrilleob@gmail.com`}
      className={`emailLink ${props.addClass ?? 'uni'}`} 
    >
      {props.text ?? 'villaggiogrilleob@gmail.com'}
    </a>
  )
}